webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(5)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(2),
  /* template */
  __webpack_require__(7),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_font_awesome_css_font_awesome_min_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_font_awesome_css_font_awesome_min_css__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'homepage'
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "masked"
  }, [_vm._v("Stepenn")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("Web Engineer")]), _vm._v(" "), _c('a', {
    staticClass: "blog",
    attrs: {
      "href": "./archives/",
      "title": "Blog"
    }
  }, [_vm._v("Blogs")])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/SimonZhangITer",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-github"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/SimonZhangr",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://weibo.com/simonzhangr",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibo"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.zhihu.com/people/SimonZhangR",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-zhihu_circle"
  })]), _vm._v(" "), _c('p', [_vm._v("Hosted by "), _c('a', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "href": "https://pages.coding.me"
    }
  }, [_vm._v("Coding Pages")])])])])
}]}

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.0edde31ac915d1a0fbd2.js